const getPercentage = (divisor, total, fixed = 2) => {
  const percentage = (divisor / total) * 100
  if (isNaN(percentage) || percentage === Infinity) return "NA"
  return `${percentage.toFixed(fixed)}%`
}

export default getPercentage
